import { useEffect, useState } from 'react';
import { CoreTextField } from '@youscience/core';
import { InputAdornment } from '@mui/material';

import SearchIcon from '@images/search.svg?react';
import ClearIcon from '@images/clear.svg?react';

import { StyledSearch } from './Search.styles';

type ChangeEvent = React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;
type KeyDownEvent = React.ChangeEvent<HTMLInputElement> & React.KeyboardEvent<HTMLElement>;

interface SearchProps {
  onBlur?: () => void;
  onEnterSearch: (value: string) => void;
  filterValue?: string;
  placeholder?: string;
  onClear: () => void;
}

export const Search = (props: SearchProps) => {
  const { onEnterSearch, onClear, placeholder = 'Search', filterValue = '', onBlur } = props;
  const [isShowClearIcon, setIsShowClearIcon] = useState(false);
  const [searchValue, setSearchValue] = useState(filterValue);

  const handleSearchKeyDown = (event: KeyDownEvent) => {
    if (event.code === 'Enter') {
      onEnterSearch(searchValue);
    }
  };

  const handleSearchChange = (event: ChangeEvent) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setSearchValue(filterValue);
    setIsShowClearIcon(filterValue.length > 0);
  }, [filterValue]);

  return (
    <StyledSearch>
      <SearchIcon />

      <CoreTextField
        size="small"
        placeholder={placeholder}
        value={searchValue}
        onKeyDown={handleSearchKeyDown}
        onChange={handleSearchChange}
        onBlur={onBlur}
        endAdornment={
          isShowClearIcon && (
            <InputAdornment position="end" onClick={onClear} data-testid="clearIcon">
              <ClearIcon />
            </InputAdornment>
          )
        }
      />
    </StyledSearch>
  );
};
